// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wHM6","largestCol":"styles_largestCol__1iMUu","smallestCol":"styles_smallestCol__2cbQh"};